import { render, staticRenderFns } from "./direction-renderer.vue?vue&type=template&id=42b8b39e"
import script from "./direction-renderer.vue?vue&type=script&lang=js"
export * from "./direction-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports